import {useCallback} from 'react';

import {
    EMPTY_ORIGINAL, EMPTY_EDITS, EMPTY_MIXED,
    buildInheritedAccessSourcesConfig,
} from './accessNodeHelpers';

const restoreEditsState = (savedValue, setEdits, setSavedNodeInfoMap) => {
    if (!savedValue?._editsState) return false;
    setEdits({
        addedIncludeAll: new Set(savedValue._editsState.addedIncludeAll),
        addedIndividual: new Set(savedValue._editsState.addedIndividual),
        removed: new Set(savedValue._editsState.removed),
    });
    if (savedValue._nodeInfoMap) {
        const restored = new Map();
        for (const [id, info] of Object.entries(savedValue._nodeInfoMap)) {
            restored.set(id, info);
        }
        setSavedNodeInfoMap(restored);
    }
    return true;
};

const useAccessInit = ({
    tree, groups, targets, isBulkMode, savedState, accessSummary,
    setOriginal, setEdits, setMixed, setAccessMap, setRemoveAll,
    setInheritedIds, setInheritedSources, setGroupMembership, setSavedNodeInfoMap,
    setSelectionSummary, resetSearch,
}) => {
    const initializeModal = useCallback(async () => {
        setOriginal(EMPTY_ORIGINAL);
        setMixed(EMPTY_MIXED);
        setAccessMap({});
        setRemoveAll(false);
        setSelectionSummary(accessSummary || {projects: 0, folders: 0, items: 0});
        resetSearch();

        const restored = restoreEditsState(savedState, setEdits, setSavedNodeInfoMap);
        if (!restored) {
            setEdits(EMPTY_EDITS);
            setSavedNodeInfoMap(new Map());
        }

        const config = buildInheritedAccessSourcesConfig(groups, targets, isBulkMode);
        setInheritedIds(config.inheritedIds);
        setInheritedSources(config.inheritedSources);
        setGroupMembership(config.groupMembership);

        if (restored && savedState?._treeSnapshot) {
            tree.restoreSnapshot(savedState._treeSnapshot);
        } else {
            await tree.reset();
        }
    }, [tree, groups, targets, isBulkMode, savedState, accessSummary, resetSearch,
        setOriginal, setEdits, setMixed, setAccessMap, setRemoveAll,
        setInheritedIds, setInheritedSources, setGroupMembership, setSavedNodeInfoMap, setSelectionSummary]);

    return {initializeModal};
};

export default useAccessInit;
